import GET_ARTICLES from '../plugins/getArticles'
import GET_INSTAGRAM from '../plugins/getInstagram';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween';

const [ w, d, mq, UA ] = [ window, document, window.matchMedia( "(max-width: 900px)" ), window.navigator.userAgent.toLowerCase() ]

const jqInit = () => {

  w.jQuery = $;

  $.when(
    w.load['mainvisual'],
    $.getScript('/asset/js/vendor/jquery.mb.YTPlayer.min.js')
  ).then( () => {
    const $MV = $('[data-plugin="ytplayer"]');
    const param = id => `{
      videoURL: '${id}',
      containment: '.mainvisual__body',
      mute: true,
      showControls: false,
      autoPlay: true,
      useOnMobile: true,
      showYTLogo: false,
      abundance: '${(mq.matches)? 0.01: 0.07}',
      stopMovieOnBlur: false,
      loop: true,
      startAt: 0,
      anchor: 'center,center',
      quality: 'default'
    }`.replace(/\n|\s/g,'');
    $MV.attr('data-property',param('23MO4aKgXlE'));
    $MV.YTPlayer();
    $MV.YTPPlay();
  });

  //mainvisual
  $.when( w.load['mainvisual'] ).then( () => {

    //トップバナー
    let $bannerBlock = $('.mainvisual__banner');

    const makeBanner = (conf = { href:'#', imgpath: '', imgpathsp: '', imgattr:'' }) => {
      return $(`
        <a href="${conf.href}" class="banner">
          <picture>
            <source media="(min-width: 900px)" srcset="/asset/img/home/${conf.imgpath}">
            <source media="(max-width: 899px)" srcset="/asset/img/home/${conf.imgpathsp}">
            <img src="/asset/img/home/${conf.imgpath}" ${conf.imgattr} />
          </picture>
        </a>
      `)
    }

    const $closeBtn = $(`<button class="button-text banner-close" type="button"><img src="/asset/img/icon_close@2x.png" alt="close" width="30" height="30"></button>`);

    dayjs.locale('ja');
    dayjs.extend(isBetween);

    if( dayjs().isBetween('2025-01-01', '2025-01-31') ) {
      $bannerBlock.append( $(`
        <a href="/news/?mode=detail&article=288" class="banner is-onlinemtg">
          <picture>
            <source media="(min-width: 900px)" srcset="/asset/img/home/banner_newyear@2x.png 406w" sizes="203px">
            <source media="(max-width: 899px)" srcset="/asset/img/home/banner_newyear_sp@2x.jpg 664w" sizes="332px">
            <img src="/asset/img/home/banner_newyear@2x.png" class="banner-img" alt="NEWYEAR" />
          </picture>
        </a>
        `));
    } else {
      $bannerBlock.append( $(`
        <a href="/recruit/" class="banner is-onlinemtg">
          <picture>
            <source media="(min-width: 900px)" srcset="/asset/img/home/banner_recruit@2x.png 406w" sizes="203px">
            <source media="(max-width: 899px)" srcset="/asset/img/home/banner_recruit_sp@2x.jpg 664w" sizes="332px">
            <img src="/asset/img/home/banner_recruit@2x.png" class="banner-img" alt="採用情報" />
          </picture>
        </a>
      `));
    }

    $closeBtn.prependTo( $('a.banner.is-onlinemtg', $bannerBlock) );

    $closeBtn.on('click', function() {
      $(this).parent().fadeOut();
      return false;
    });

    // if( dayjs().isBetween('2022-01-01', '2022-01-30 00:00:00')) {
    //   $bannerBlock.append( makeBanner({
    //     href: '/service/?mode=detail&article=6',
    //     imgpathsp: 'banner_onlinemtg_sp@2x.jpg',
    //     imgpath: 'banner_onlinemtg@2x.png',
    //     imgattr: 'alt="ONLINE MEETING(オンラインミーティング)対応いたします。" data-ie-width="204"'
    //   }));
    // }

    // ticker
    let makeItem = item => $(`
      <a href="${item.href}" class="link">
        <span class="cat">${item.category.name}</span>
        <span class="date">${item.date}</span>
        <span class="subject">${item.title}</span>
      </a>
    `)[0];
    GET_ARTICLES( '.block-ticker__article[data-plugin="getArticles"]', { makeItem });
  });

  // works
  $.when( w.load['block-works'] ).then( () => {
    let makeItem = item => {
      const $item = $(`
        <li class="works-item">
          <a class="works-item__link" href="${item.href}">
            <figure class="works-item__img">
              <div class="works-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="220"></div>
              <svg class="cover" width="100%" height="100%">
                <circle class="front-hover" cx="0" cy="0" r="0"></circle>
              </svg>
            </figure>
            <div class="works-item__body">
              <span class="subject ${item.is_new ? 'is-new': ''}">${item.title.str_truncate(40)}</span>
            </div>
          </a>
          <div class="works-item__foot">
            <span class="cate"><i class="fa fa-tag"></i><a href="${item.category.href}">${item.category.name}</a></span>
            ${( item.keywords != null && item.keywords.length != 0)? `<span class="tags"></span>`:''}
          </div>
        </li>
      `);
      if( item.keywords != null && item.keywords.length > 0 ){
        item.keywords.slice(0,3).forEach(tag => {
          $('.works-item__foot .tags', $item).append(`<a href="/works/?mode=list&tag=${encodeURI(tag)}">#${tag}</a>`);
        });
      }
      return $item[0];
    }
    GET_ARTICLES( '.block-works__list[data-plugin="getArticles"]', { makeItem }).then( () => {

      const $svgs = $('svg.cover', '.works-item');
      $svgs.each((i,v) => {
        let hoverObj = v.querySelector('circle.front-hover');
        v.addEventListener('mouseenter', e => {
          hoverObj.setAttribute( 'cx', e.offsetX );
          hoverObj.setAttribute( 'cy', e.offsetY );
          hoverObj.setAttribute( 'r', '865' );
        });
        v.addEventListener('mouseleave', e => {
          hoverObj.setAttribute( 'r', '0' );
        })
      })

      const elem = d.querySelector('.block-works__list');
      // layout Masonry after each image loads
      imagesLoaded( elem, function( instance ) {
        const msnry = new Masonry( elem, {
          // options
          itemSelector: '.works-item'
        });
      });
    });

  });

  $.when(w.load['block-service']).then( () => {
    const elem = d.querySelector('.block-service');
    const $item = $('.block-service__item');
    imagesLoaded( elem, () => {
      $item.each( function() {
        let $itemImg = $('img.anim',this);
        let path = $itemImg.attr('src');
        let coverPath = path.replace(/_anim@2x\.gif$/,'_cover@2x.gif');
        $itemImg.attr('src', coverPath);
        $(this).on({
          mouseenter(){ $itemImg.attr('src', path); },
          mouseleave(){ $itemImg.attr('src', coverPath); }
        });
      });
    });
  });

  // blog
  $.when(w.load['block-blog']).then( () => {
    let makeItem = item => {
      const $item = $(`
        <li class="block-blog-item">
          <a href="${item.href}" class="block-blog-item__link">
            <figure class="block-blog-item__img">
              <div class="block-blog-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="220" loading="lazy"></div>
            </figure>
            <div class="block-blog-item__body">
              <span class="date">${item.date}</span>
              <span class="subject ${item.is_new ? 'is-new': ''}">${item.title.str_truncate(24)}</span>
            </div>
          </a>
          <div class="block-blog-item__foot">
            ${( item.keywords != null && item.keywords.length != 0)? `<span class="tags"></span>`:''}
          </div>
        </li>
      `);
      if( item.keywords != null && item.keywords.length > 0 ){
        item.keywords.forEach(tag => {
          $('.block-blog-item__foot .tags', $item).append(`<a href="/news/?mode=list&tag=${encodeURI(tag)}">#${tag}</a>`);
        });
      }
      return $item[0];
    }
    GET_ARTICLES('.block-blog__list[data-plugin="getArticles"]', { makeItem });
  });

  // news
  $.when(w.load['block-news']).then( () => {
    let makeItem = item => $(`
      <li class="block-news-item">
        <a href="${item.category.href}" class="cate">${item.category.name}</a>
        <span class="date">${item.date}</span>
        <a class="block-news-item__link" href="${item.href}">
          <span class="subject ${item.is_new ? 'is-new': ''}">${item.title}</span>
        </a>
      </li>
    `)[0]
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]', { makeItem });
  });

  // sns
  $.when( w.load['block-sns'] ).then( () => GET_INSTAGRAM() );

  // fixed sns
  $.when( w.load['footer'] ).then( () => {
    // ボタンの色をスクロール量で変化させる
    const $fixedBtn = $('.footer__social.is-fixed').addClass('is-dark');
    $.scrollspy({
      trigger: w.innerHeight - 200,
      onBefore() {
        $fixedBtn.addClass('is-dark');
      },
      onAfter() {
        $fixedBtn.removeClass('is-dark');
      }
    })
  });

}

export default function HOME() {

  $( jqInit );

}